import axios from "axios";

export const umbracoApi = axios.create({
    baseURL: 'https://cdn.umbraco.io/content/',
    headers: {
      Accept: "application/json",
      "Accept-Language": "en-us",
      "Api-Version": 2.1,
      "Api-Key": 'ua06V56OTkZFPRn3GPLP',
      "Umb-Project-Alias": 'ken-s-shy-kangaroo',
    },
  });